import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { CsProject } from './cs-project.model';

export const csProjectStoreName = 'cs-projects';
export interface CsProjectState extends EntityState<CsProject> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: csProjectStoreName })
export class CsProjectStore extends EntityStore<CsProjectState> {
    constructor() {
        super();
    }
}
